import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import App from './App';
import { LanguageProvider } from './hooks/useLanguage';
import { MeasurementProvider } from './hooks/useMeasurement';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2'
    },
    yellow: {
      main: '#f5cc00',
      dark: '#b09300',
      light: '#fce25b',
      contrastText: '#000'
    }
  }
})

const oidcConfig = {
  authority: window._env_.KEYCLOAK_URL + "/realms/immersight",
  client_id: 'ims-filesapi-frontend',
  redirect_uri: window._env_.REDIRECT_URI,
  scope: 'openid profile email immersight-claims',
  post_logout_redirect_uri: window._env_.POST_LOGOUT_URI,
};


root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <LanguageProvider>
        <MeasurementProvider>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </MeasurementProvider>
      </LanguageProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
